import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const HalleStellungangebot = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const benefits = [
    'Unbefristeter Arbeitsvertrag',
    'Übertarifliche Bezahlung',
    'Flexible Arbeitszeiten',
    'Fort- und Weiterbildungsmöglichkeiten',
    'Familiäres Arbeitsklima',
    'Wertschätzung und Respekt',
    'Dienstfahrzeug möglich',
    'Betriebliche Altersvorsorge'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-turquoise-50 to-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 px-4 overflow-hidden" data-testid="halle-karriere-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-turquoise-400 to-turquoise-300 opacity-10"></div>
        <div className="container mx-auto text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Karriere in Halle
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Werden Sie Teil unseres Teams in <span className="text-turquoise-400 font-bold">Halle (Saale)</span>
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Wir suchen Verstärkung!
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Für unseren wachsenden Standort in Halle (Saale) suchen wir engagierte Mitarbeiterinnen und Mitarbeiter, die mit Herz und Kompetenz Teil unseres Teams werden möchten. Ob Pflegefachkraft oder Pflegehelfer – bei uns sind Sie willkommen!
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Das bieten wir Ihnen:
            </h3>
            <ul className="space-y-3 mb-8">
              {benefits.map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-turquoise-400 mr-3 mt-1">✓</span>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>

            <div className="grid md:grid-cols-2 gap-6 mt-8">
              <Link 
                to="/halle/karriere/pflegefachkraft"
                className="bg-gradient-to-br from-turquoise-400 to-turquoise-500 text-white rounded-2xl p-6 hover:shadow-xl transition-all"
              >
                <h4 className="text-xl font-bold mb-2">Pflegefachkraft (m/w/d)</h4>
                <p className="text-turquoise-100">Examinierte Pflegekräfte gesucht</p>
              </Link>
              <Link 
                to="/halle/karriere/pflegehelfer"
                className="bg-gradient-to-br from-green-500 to-green-600 text-white rounded-2xl p-6 hover:shadow-xl transition-all"
              >
                <h4 className="text-xl font-bold mb-2">Pflegehelfer (m/w/d)</h4>
                <p className="text-green-100">Auch Quereinsteiger willkommen</p>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 px-4 bg-white">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-gradient-to-br from-turquoise-50 to-turquoise-100 rounded-3xl shadow-xl p-8 md:p-12 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Interesse geweckt?</h2>
            <p className="text-lg text-gray-700 mb-8">
              Senden Sie uns Ihre Bewerbung oder rufen Sie uns einfach an – wir freuen uns auf Sie!
            </p>
            <div className="space-y-4">
              <p className="text-gray-700">
                <strong>Telefon:</strong> <a href="tel:034568669465" className="text-turquoise-400 hover:underline">0345-68669465</a>
              </p>
              <p className="text-gray-700">
                <strong>E-Mail:</strong> <a href="mailto:info@grossstadtherzen-halle.de" className="text-turquoise-400 hover:underline">info@grossstadtherzen-halle.de</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-gradient-to-br from-turquoise-400 to-turquoise-500 text-white">
        <div className="container mx-auto text-center max-w-4xl">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Jetzt bewerben!
          </h2>
          <p className="text-xl mb-8">
            Starten Sie Ihre Karriere bei Großstadtherzen® Halle
          </p>
          <a 
            href="mailto:info@grossstadtherzen-halle.de"
            className="inline-block bg-white text-turquoise-500 px-8 py-4 rounded-full text-lg font-semibold hover:bg-turquoise-50 transition-all shadow-lg"
            data-testid="halle-karriere-bewerben-btn"
          >
            Bewerbung senden
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HalleStellungangebot;
